<script setup lang="ts">
import { onMounted, ref, watch } from "vue";
import { video_pressets } from "../utils/video_pressets";
import MicroButtonPreview from "./preview/MicroButtonPreview.vue";
import CameraButtonPreview from "./preview/CameraButtonPreview.vue";
import SettingButton from "./preview/SettingButton.vue";
import { tile_info } from "../states/auth";
import { getRandomBg } from "../utils/randomBg";
import MoreButton from "./preview/MoreButton.vue";
import { openSettingModal, viewState } from "../states/viewState";
import { cameraTrack, desiredMediaState, init } from "../states/media/state";

const videoEl = ref<HTMLVideoElement | null>(null);
onMounted(async () => {
  init()
  watch(
    () => ({
      track: cameraTrack.value,
      state: desiredMediaState.cameraEnabled,
      el: videoEl.value,
    }),
    (next) => {
      if (next.track && next.state && next.el) {
        next.track.attach(next.el);
      }
    },
  );
});
</script>
<template>
  <div class="preview-video">
    <div class="card-container border">
      <video
        v-if="desiredMediaState.cameraEnabled"
        class="video-el mirror"
        ref="videoEl"
        :width="260"
        :height="147"
        autoplay
        :controls="false"
      />
      <div
        v-else
        class="image-preview"
        :style="{
          width: `${video_pressets.preview.width}px`,
          height: `${video_pressets.preview.height}px`,
        }"
      >
        <div
          class="preview-avatar-size preview-avatar"
          :style="{
            backgroundColor:
              tile_info.name && !tile_info.avatar
                ? getRandomBg(tile_info.name)
                : '#d9d9d9',
          }"
        >
          <img
            v-if="tile_info.avatar"
            class="covered"
            :src="tile_info.avatar"
            alt=""
          />
          <span v-else-if="tile_info.name" class="covered name-char">{{
            tile_info.name
          }}</span>
          <img v-else src="@images/default_avatar.svg" class="covered" />
        </div>
      </div>
    </div>
    <div class="controls">
      <MicroButtonPreview />
      <CameraButtonPreview />
      <SettingButton @click="openSettingModal" />
      <MoreButton @click="viewState.detailDialog = true" />
    </div>
  </div>
</template>
<style scoped>
.card-container {
  width: 260px;
  height: 147px;
  display: flex;
  flex-direction: column;
}

.preview-video {
  height: 195px;
  width: 260px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.border {
  position: relative;
}

.border::after {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 4px solid transparent;
  border-radius: 8px;
  z-index: 10;
  transition: border-color ease-in 150ms;
}

.controls {
  height: 36px;
  width: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.video-el {
  border-radius: 8px;
  background: #d9d9d9;
}

.mirror {
  transform: scaleX(-1);
}

.audio-el {
  display: none;
}

.image-preview {
  max-width: 100%;
  display: flex;
  border-radius: 8px;
  background-color: #d9d9d9;
  align-items: center;
  justify-content: center;
}

.preview-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
}

.name-char {
  font-size: 30px;
  color: #FFFFFF;
  text-align: center;
}
</style>
